module.exports = __webpack_public_path__ + "static/media/bradesco-ico.50fdb4c5.svg";